import React, { useState, useEffect, useRef } from "react";
import {
  Avatar,
  Box,
  Badge,
  Button,
  Checkbox,
  Grid,
  TextField,
  Typography,
  FormControl,
  FormControlLabel,
  MenuItem,
  Modal,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputLabel,
  Select,
} from "@mui/material";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { useCardDetailContext } from "../../../CardDetailContext";
import { useUserDetailContext } from "../../../UserDetailContext";
import { ReactComponent as AiLogo } from "../../../../Assets/img/icons/ai-rewrite-logo.svg";
import { Snackbar, InputAdornment } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EventIcon from "@mui/icons-material/Event";
// import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
// import { LuPlusCircle } from "react-icons/lu";
import axios from "axios";
import Cropper from "react-cropper";
import {
  CustomChip,
  customHealthPaper,
} from "../../MyProfileDetails/PersonalProfile";
import "cropperjs/dist/cropper.css";
import DeleteIcon from "@mui/icons-material/Delete";
import { FaPlusCircle } from "react-icons/fa";
import Autocomplete from "@mui/material/Autocomplete";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import FileDragUpload from "../../../Utilities/FileDragUpload";
import useNavigationGuard from "./useNavigationGuard";
import { useQuantityContext } from "../../../QuantityContext";
import Popper from "@mui/material/Popper";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as TickIcon } from "../../../../Assets/img/icons/tick-shape.svg";
import useApi from "../../../Utilities/useAPI";
import {
  getAllCardDetailsReducer,
  getAllCardInfoReducer,
  getVisitingCardReducer,
  patchProfessionalCardReducer,
  patchStudentCardReducer,
  postCardProfileLogoReducer,
} from "../../../../Redux/Reducers/CardReducer";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import CryptoJS from "crypto-js";
import {
  getEducationLogoReducer,
  getEducationReducer,
  getExperienceReducer,
  getLogoReducer,
  postGenerateDescriptionReducer,
} from "../../../../Redux/Reducers/ProfileReducer";
import API from "../../../../utils/APIUtils";

const ProfileDetails = ({ handleSuccess, handleFailure }) => {
  const {
    cardDetails,
    setCardDetails,
    updateCardDetails,
    CardStyles,
    updateCardStyles,
    setOtherCards,
    updateContactStyles,
    updateCardQrStyles,
    updateSocialLinks2,
  } = useCardDetailContext();
  const { userDetails, setUserDetails } = useUserDetailContext();
  const { setisNavigationBlocked } = useQuantityContext();
  const { callApiFunction } = useApi();

  const Allcards = useSelector((state) => state?.CardArray?.AllCardDetailsInfo);

  const currentYear = new Date().getFullYear();

  const years = Array.from(
    { length: currentYear - 1970 + 1 },
    (_, index) => currentYear - index
  );

  const filteredCardName = Allcards?.filter(
    (card) =>
      card?.card_name?.toLowerCase().trim() ===
      cardDetails?.CardName?.toLowerCase().trim()
  );

  console.log("cardDetailscardDetails-------------------", cardDetails);
  const fullName = userDetails.name;
  // console.log("full name", userDetails);

  const [firstName, lastName] = fullName.split(" ");
  const [SaveEnable, setSaveEnable] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState({
    title: "",
    body: "",
  });
  const message = "You have some UnSaved Changes. Do u want to leave ?";
  useNavigationGuard(SaveEnable, setSaveEnable, message);
  const AllCardsInfos = useSelector((state) => state.CardArray.AllCardsInfo);
  const dispatch = useDispatch();
  const encryptedId = encodeURIComponent(
    CryptoJS.AES.encrypt(
      userDetails.reference_id.toString(),
      "UserDetailsSecretKey"
    ).toString()
  );
  const [initialCardDetails, setInitialCardDetails] = useState({});
  const [image, setImage] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isDbavailable, setDbavailable] = useState(true);
  const cropperRef = useRef(null);
  const [cropperInitialized, setCropperInitialized] = useState(false);
  const [responsibilityInput, setResponsibilityInput] = useState("");

  const [selectedExperience, setSelectedExperience] = useState(null);
  const [selectedExperienceDomain, setSelectedExperienceDomain] =
    useState(null);
  const [selectedInstitute, setSelectedInstitute] = useState(null);
  const [companySearchTerm, setCompanySearchTerm] = useState(
    cardDetails?.company
  );
  const [cardInstitueSearchItem, setCardInstitueSearchItem] = useState(
    cardDetails?.institute
  );
  const [professionalSearchDomain, setProfessionalSearchDomain] = useState(
    cardDetails?.company_website
  );
  const [studentDomainSearchItem, setStudentDomainSearchItem] = useState(
    cardDetails?.institute_domain
  );
  const [loading, setLoading] = useState(false);
  const [selectedCardEducation, setSelectedCardEducation] = useState({});
  const [menuItem, setMenuItem] = useState();

  const [searchItems, setSearchItems] = useState([]);

  const isOnlyNumbers = /^\d+$/;

  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem("objectId");
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
  };

  const kpiOptions = [
    "API Response Time",
    "Average Order Fulfillment Time",
    "Average Resolution Time",
    "A/B Test Results",
    "Annual Revenue Growth",
    "Audience Retention Rate",
    "Bounce Rate",
    "Brand Awareness Metrics",
    "Budget Variance",
    "Bug Fix Rate",
    "Candidate Satisfaction Score",
    "Click-Through Rate (CTR)",
    "Close Rate (Sales Conversion Rate)",
    "Code Quality",
    "Code Review Efficiency",
    "Code Velocity",
    "Conversion Rate from Content",
    "Conversion Rate from Design Changes",
    "Cost per Acquisition (CPA)",
    "Cost Reduction Ratio",
    "Customer Acquisition Cost (CAC)",
    "Customer Feedback Volume",
    "Customer Lifetime Value (CLV)",
    "Customer Retention Rate",
    "Customer Satisfaction Score (CSAT)",
    "Database Optimization",
    "Deliverable Timeliness",
    "Employee Satisfaction Rate",
    "Employee Turnover Rate",
    "Error Rate",
    "First Call Resolution Rate",
    "Feature Adoption Rate",
    "Financial Forecast Accuracy",
    "Gross Profit Margin",
    "Hiring Time (Time to Hire)",
    "Incident Response Time",
    "Inventory Turnover Ratio",
    "Lead Conversion Rate",
    "Leads Generated from Content",
    "Mean Time Between Failures (MTBF)",
    "Monthly Sales Quota Achievement",
    "Net Promoter Score (NPS)",
    "On-Time Delivery Rate",
    "Operating Cash Flow",
    "Page Load Speed",
    "Profitability Ratio",
    "Return on Assets (ROA)",
    "Return on Equity (ROE)",
    "Sales Revenue per Rep",
    "Server Uptime",
    "Sprint Completion Rate",
    "Time to Market",
    "Unit Test Coverage",
    "User Feedback Rating",
  ];

  const handleAddChip = (event, input, field) => {
    const keyPressed = event.key;
    const inputValue = input.trim();

    // Only handle 'Enter' or ',' keys when there's input to add
    if ((keyPressed === "Enter" || keyPressed === ",") && inputValue) {
      event.preventDefault(); // Prevent default before updating state
      updateCardDetails((prevState) => {
        const fieldValue = prevState[field];
        if (Array.isArray(fieldValue)) {
          return {
            ...prevState,
            [field]: [...fieldValue, inputValue],
          };
        } else {
          console.error(`${field} is not an array.`);
          return prevState;
        }
      });
      setResponsibilityInput("");
    }
  };

  const handleDeleteChip = (field, chipToDelete) => {
    updateCardDetails((prevState) => ({
      ...prevState,
      [field]: prevState[field].filter((chip) => chip !== chipToDelete),
    }));
  };
  useEffect(() => {
    setInitialCardDetails(cardDetails);
  }, []);

  useEffect(() => {
    setSaveEnable(
      JSON.stringify(initialCardDetails) !== JSON.stringify(cardDetails)
    );
    setisNavigationBlocked(
      JSON.stringify(initialCardDetails) !== JSON.stringify(cardDetails)
    );
  }, [cardDetails, initialCardDetails]);

  const handleInputChange = (fieldName) => (event) => {
    const newValue = event.target.value;
    updateCardDetails({ [fieldName]: newValue });
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleChangeCardName = (event) => {
    const newValue = event.target.value;
    updateCardDetails({ CardName: newValue });
    updateCardStyles({ CardName: newValue });
    updateCardQrStyles({ CardName: newValue });
    updateSocialLinks2({ CardName: newValue });
    updateContactStyles({ CardName: newValue });
  };
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    event.target.value = "";
    // Remove spaces and parentheses from the file name
    const cleanedFileName = file.name.replace(/\s+/g, "").replace(/[()]/g, "");

    // Create a new File object with the cleaned file name
    const cleanedFile = new File([file], cleanedFileName, { type: file.type });

    const imageUrl = URL.createObjectURL(cleanedFile);
    setSelectedFile(cleanedFile);
    setSelectedImage(imageUrl);
    setOpenDialog(true);
  };

  const handleCropSave = () => {
    // console.log("Clicking save button");

    if (!cropperRef.current || !cropperRef.current.getCroppedCanvas) {
      console.error(
        "Cropper not initialized or getCroppedCanvas function not available."
      );
      return;
    }

    const canvas = cropperRef.current.getCroppedCanvas();

    if (canvas) {
      canvas.toBlob((blob) => {
        const croppedFile = new File(
          [blob],
          selectedFile.name || "croppedImage.jpg",
          {
            type: selectedFile.type || "image/jpeg",
          }
        );

        // Update selected image state
        setSelectedImage(URL.createObjectURL(croppedFile));

        // Prepare image object for form data
        const imageObject = {
          name: croppedFile.name,
          type: croppedFile.type,
          data: selectedImage,
        };
        // console.log("CROPPED Image", imageObject);
        updateCardDetails({ profile_pic: imageObject?.data });
        setOpenDialog(false);
        handleFileUpload(croppedFile);
      }, "image/jpeg");
    } else {
      console.error("Canvas not available after cropping.");
    }
  };

  // Function to handle file upload to server
  const handleFileUpload = async (file) => {
    if (!file) {
      console.error("No file to upload.");
      return;
    }
    console.log("Cropper Image", file);
    try {
      // const formData = new FormData();
      // formData.append('file', file);

      // const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url`, formData, {
      //   headers: {
      //     'Content-Type': 'multipart/form-data',
      //   },
      // });

      // Assuming your response structure is like { sasUrl: 'some_url' }
      // const sasUrl = response.data.url;

      // console.log("File uploaded successfully!", sasUrl);
      const fileUrl = URL.createObjectURL(file);
      updateCardDetails({ profile_pic: fileUrl });
      setSelectedImage(null);
      setSelectedFile(null);
    } catch (error) {
      console.error("Error uploading file:", error.message);
      handleInfo("Error uploading file. Please check the console for details.");
    }
  };

  const handleSearchLogo = (event, newInputValue) => {
    console.log("search Logoggg", newInputValue);

    if (menuItem === "Student") {
      // When typing, only update the institute name, reset logo/domain
      setSelectedInstitute(null); // deselect any previously selected item
      setCardInstitueSearchItem(newInputValue);
      setCardDetails((prev) => ({
        ...prev,
        institute: newInputValue,
        // instlogo: { name: "logo", type: "image/png", data: "" },
        // instituteDomain: ""
      }));
    }
    if (menuItem === "Professional") {
      setSelectedExperience(null);
      setCompanySearchTerm(newInputValue);
      setCardDetails((prev) => ({
        ...prev,
        company: newInputValue,
        // DON’T reset companyDomain here
        // companylogo: { name: "logo", type: "image/png", data: "" },
      }));
    }
  };

  const handleSelected = (event, selectedValue) => {
    console.log("Selected Logo:", selectedValue);
    setSearchItems(null);

    if (menuItem === "Professional") {
      if (!selectedValue) {
        setSelectedExperience(null);
        setCardDetails({
          ...cardDetails,
          company: "",
          company_website: "",
          logo: { name: "logo", type: "image/png", data: "" },
        });
      } else {
        setSelectedExperience(selectedValue);
        setCompanySearchTerm(selectedValue?.legal_name || "");

        setCardDetails({
          ...cardDetails,
          company: selectedValue?.legal_name,
          company_website: selectedValue?.website || "",
          logo: {
            name: "logo",
            type: "image/png",
            data: selectedValue?.logo || "",
          },
        });

        setProfessionalSearchDomain(selectedValue?.website || " ");
      }
    }

    if (menuItem === "Student") {
      if (!selectedValue) {
        setSelectedInstitute(null);
        setCardDetails({
          ...cardDetails,
          institute: "",
          institute_domain: "",
          logo: { name: "logo", type: "image/png", data: "" },
        });
      } else {
        setSelectedInstitute(selectedValue);
        setCardInstitueSearchItem(selectedValue?.legal_name || "");

        setCardDetails({
          ...cardDetails,
          institute: selectedValue?.legal_name,
          institute_domain: selectedValue?.website || "",
          logo: {
            name: "logo",
            type: "image/png",
            data: selectedValue?.logo || "",
          },
        });

        setStudentDomainSearchItem(selectedValue?.website || " ");
      }
    }
  };

  const handleSelectedDomain = (event, selectedvalue) => {
    console.log("SELECTED LOGO", selectedvalue);
    setSearchItems(null);

    if (menuItem === "Student") {
      if (!selectedvalue || typeof selectedvalue === "string") {
        setSelectedExperienceDomain(null);
        setCardDetails({
          ...cardDetails,
          institute: "",
          institute_domain: "",
          logo: { name: "logo", type: "image/png", data: "" },
        });
      } else {
        setSelectedExperienceDomain(selectedvalue);
        setStudentDomainSearchItem(selectedvalue?.website || " ");
        setCardDetails({
          ...cardDetails,
          institute: selectedvalue?.legal_name || "",
          institute_domain: selectedvalue?.website || "",
          logo: {
            name: "logo",
            type: "image/png",
            data: selectedvalue?.logo || "",
          },
        });

        setCardInstitueSearchItem(selectedvalue?.legal_name || "");
      }
    }

    if (menuItem === "Professional") {
      if (!selectedvalue || typeof selectedvalue === "string") {
        setSelectedExperienceDomain(null);
        setCardDetails({
          ...cardDetails,
          company: "",
          company_website: "",
          logo: { name: "logo", type: "image/png", data: "" },
        });
      } else {
        setSelectedExperienceDomain(selectedvalue);
        setProfessionalSearchDomain(selectedvalue?.website || " ");
        setCardDetails({
          ...cardDetails,
          company: selectedvalue?.legal_name || "",
          company_website: selectedvalue?.website || "",
          logo: {
            name: "logo",
            type: "image/png",
            data: selectedvalue?.logo || "",
          },
        });

        setCompanySearchTerm(selectedvalue?.legal_name || "");
      }
    }
  };

  const handleSearchDomain = (event, value) => {
    console.log("search Logoggg", value);

    if (menuItem === "Student") {
      // When typing, only update the institute name, reset logo/domain
      // setSelectedInstituteDomain(null);
      // // deselect any previously selected item]

      setSelectedExperienceDomain(null);
      setStudentDomainSearchItem(value);
      setCardDetails((prev) => ({
        ...prev,
        // institute: "",
        // instlogo: { name: "logo", type: "image/png", data: "" },
        institute_domain: value,
      }));
    }

    if (menuItem === "Professional") {
      setSelectedExperienceDomain(null);
      setProfessionalSearchDomain(value);
      setCardDetails((prev) => ({
        ...prev,
        company_website: value,
        // DON’T reset companyName here
        // companylogo: { name: "logo", type: "image/png", data: "" },
      }));
    }
  };

  useEffect(() => {
    if (!companySearchTerm) {
      // Ensure API is called only when there's a search value
      setSearchItems([]);
      return;
    }
    const delayDebouncing = setTimeout(() => {
      getLogo(companySearchTerm);
    }, 500);
    return () => clearTimeout(delayDebouncing);
  }, [companySearchTerm]);

  useEffect(() => {
    if (!cardInstitueSearchItem) {
      // Ensure API is called only when there's a search value
      setSearchItems([]);
      return;
    }
    const delayDebouncing = setTimeout(() => {
      getEducationLogo(cardInstitueSearchItem);
    }, 500);
    return () => clearTimeout(delayDebouncing);
  }, [cardInstitueSearchItem]);

  useEffect(() => {
    if (!professionalSearchDomain) {
      return;
    }
    const delayDebouncing = setTimeout(() => {
      getLogo(professionalSearchDomain); //  only pass domain
    }, 500);

    return () => clearTimeout(delayDebouncing);
  }, [professionalSearchDomain]);

  useEffect(() => {
    if (!studentDomainSearchItem) {
      return;
    }
    const delayDebouncing = setTimeout(() => {
      getEducationLogo(studentDomainSearchItem); //  only pass domain
    }, 500);

    return () => clearTimeout(delayDebouncing);
  }, [studentDomainSearchItem]);

  const getLogo = async (searchValue) => {
    try {
      const response = await dispatch(getLogoReducer(searchValue));
      console.log("Logo response", response);
      if (response?.payload?.statusCode === 200) {
        setSearchItems(response?.payload?.data);
      }
    } catch (error) {
      console.log("API EROR", error);
    }
  };

  const getEducationLogo = async (searchValue) => {
    try {
      const response = await dispatch(getEducationLogoReducer(searchValue));
      console.log("Logo response", response);
      if (response?.payload?.statusCode === 200) {
        setSearchItems(response?.payload?.data);
      }
    } catch (error) {
      console.log("API EROR", error);
    }
  };

  useEffect(() => {
    if (
      openDialog &&
      selectedImage &&
      !cropperInitialized &&
      cropperRef.current
    ) {
      console.log("Initializing cropper...");
      setCropperInitialized(true);
    }
  }, [openDialog, selectedImage, cropperInitialized]);

  // Function to handle cropper initialization
  const handleCropperInitialized = (instance) => {
    cropperRef.current = instance;
  };

  const [expanded, setExpanded] = useState(false);

  // console.log("CARD DETAILS ", cardDetails);
  const handleSave = async (event) => {
    event.preventDefault();

    try {
      console.log("CARD DETAILS ", cardDetails);
      const formData = new FormData();

      const appendIfDefined = (key, value) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      };

      appendIfDefined("User_ID", cardDetails?.User_ID);
      appendIfDefined("CardType", cardDetails?.CardType);
      // appendIfDefined('CardName', cardDetails?.CardName);
      appendIfDefined("employee_id", cardDetails?.employee_id);
      appendIfDefined("company_id", cardDetails?.company_id);
      appendIfDefined("profession_department", cardDetails?.profession_department);
      // appendIfDefined('employee_id', cardDetails?.employee_id);
      // appendIfDefined("company_id", cardDetails?.company_id);
      appendIfDefined("location", cardDetails?.location);
      appendIfDefined("location_type", cardDetails?.location_type);
      appendIfDefined("profile_headline", cardDetails?.profile_headline);
      // appendIfDefined('responsibility', cardDetails?.responsibility.join(", "));

      appendIfDefined("responsibility", Array.isArray(cardDetails?.responsibility) ? cardDetails.responsibility.join(", ") : cardDetails?.responsibility || "");
      appendIfDefined("profession_id", cardDetails?.profession_id);
      appendIfDefined("company_website", cardDetails?.company_website);
      appendIfDefined("is_professional_verified", cardDetails?.is_professional_verified ? 1 : 0);
      appendIfDefined("professional_details_status", cardDetails?.professional_details_status);
      appendIfDefined("student_id", cardDetails?.student_id);
      appendIfDefined("student_email_id", cardDetails?.student_email_id);
      appendIfDefined("student_year", cardDetails?.student_year);
      appendIfDefined("student_ending_year", cardDetails?.student_currently_pursuing ? new Date().getFullYear() : cardDetails?.student_ending_year);
      appendIfDefined("student_currently_pursuing", cardDetails?.student_currently_pursuing ? 1 : 0);
      appendIfDefined("educational_level", cardDetails?.education_level);
      appendIfDefined("institute", cardDetails?.institute);
      appendIfDefined("start_year", cardDetails?.start_year);

      // appendIfDefined('end_year', cardDetails?.student_currently_pursuing ? new Date().getFullYear() : cardDetails?.student_ending_year);
      appendIfDefined("end_year", cardDetails?.is_experience_current ? new Date().getFullYear() : cardDetails?.end_year);
      appendIfDefined("board", cardDetails?.board);
      appendIfDefined("degree", cardDetails?.degree);
      appendIfDefined("field_of_study", cardDetails?.field_of_study);
      appendIfDefined("grade", cardDetails?.grade);
      appendIfDefined("institute_domain", cardDetails?.institute_domain);
      appendIfDefined("university_website", cardDetails?.university_website);
      appendIfDefined("is_student_verified", cardDetails?.is_student_verified ? 1 : 0);
      appendIfDefined("student_details_status", cardDetails?.student_details_status);
      appendIfDefined("prefix", cardDetails?.prefix);
      appendIfDefined("suffix", cardDetails?.suffix);
      appendIfDefined("title", cardDetails?.title);
      appendIfDefined("nickname", cardDetails?.nickname);
      appendIfDefined("summary", cardDetails?.summary);
      appendIfDefined("designation", cardDetails?.role_title);
      appendIfDefined("company", cardDetails?.company);
      appendIfDefined("professional_email_id", cardDetails?.professional_email_id);

      appendIfDefined("is_currently_working", Boolean(cardDetails?.is_experience_current) ? true : false);
      appendIfDefined("DOB", cardDetails?.DOB);
      appendIfDefined("role_title", cardDetails?.role_title);
      appendIfDefined("details", cardDetails?.details);

      if (cardDetails?.additionalFields) {
        Object.entries(cardDetails.additionalFields).forEach(([key, value]) => {
          appendIfDefined(`additionalFields[${key}]`, value);
        });
      }

      if (cardDetails?.profile_pic) {
        const response = await fetch(cardDetails?.profile_pic);
        const blob = await response.blob();
        appendIfDefined("profile_pic", blob);
      }

      if (cardDetails?.logo) {
        const logoUrl = cardDetails?.logo?.data || cardDetails?.logo;

        if (logoUrl.startsWith("blob:")) {
          setLoading(true);
          handleInfo("Please wait to complete the process");

          try {
            const response = await fetch(logoUrl);
            const blob = await response.blob();
            const file = new File([blob], cardDetails?.logo?.name, {
              type: cardDetails?.logo?.type,
            });
            appendIfDefined("logo_file", blob, cardDetails?.logo?.name);
          } catch (error) {
            console.error("Error fetching File", error);
          }

          setLoading(false);
        } else {
          appendIfDefined("logo", logoUrl);
        }
      }

      if (
        cardDetails?.CardType === "Student" ||
        cardDetails?.CardType === "Customize_Student"
      ) {
        try {
          const resolvedCardId = isNaN(cardDetails?.card_id)
            ? filteredCardName?.[0]?.id
            : cardDetails?.card_id;

          // console.log("Resolved Student Card ID:", resolvedCardId);

          const response = await dispatch(
            patchStudentCardReducer({
              id: Number(resolvedCardId),
              data: formData,
            })
          );
          console.log("RESPONSE", response);

          await dispatch(getEducationReducer());
        } catch (error) {
          console.log("API ERROR", error);
        }
      }

      if (
        cardDetails?.CardType === "Professional" ||
        cardDetails?.CardType === "Customize_Professional"
      ) {
        try {
          const resolvedCardId = isNaN(cardDetails?.card_id)
            ? filteredCardName?.[0]?.id
            : cardDetails?.card_id;

          // console.log("Resolved Professional Card ID:", resolvedCardId);
          const response = await dispatch(
            patchProfessionalCardReducer({
              id: Number(resolvedCardId),
              data: formData,
            })
          );
          console.log("RESPONSE IN THE Professional update", response);
          await dispatch(getExperienceReducer());
        } catch (error) { }
      }

      if (
        cardDetails?.CardType === "Personal" ||
        cardDetails?.CardType === "Customize_Personal"
      ) {
        appendIfDefined("CardName", cardDetails?.CardName);
        const response = await dispatch(postCardProfileLogoReducer(formData));
        console.log("Data from Profile page ", response?.data);
      }

      // await axios.post(`${process.env.REACT_APP_BACKEND_URL}/card/personaldata`, cardDetails, {
      //   headers: headers
      // });
      // console.log('Response from backend:', response);
      setInitialCardDetails(cardDetails);

      await dispatch(getAllCardDetailsReducer());
      await dispatch(getAllCardInfoReducer());

      await dispatch(getVisitingCardReducer());

      handleSuccess();
    } catch (error) {
      console.error("Error submitting card details:", error);
      handleFailure();
    }
  };

  const PhoneInputMenuProps = {
    PaperProps: {
      style: {
        maxHeight: 48 * 4.5, // set the max height for the dropdown menu
        width: "auto", // auto width to match the TextField
      },
    },
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },

    transformOrigin: {
      vertical: "top",
      horizontal: "left",
    },
    getContentAnchorEl: null, // to ensure the menu doesn't move unexpectedly
  };

  const [universities, setUniversities] = useState([]);
  const [searchText1, setSearchText1] = useState(cardDetails?.institute || "");
  const [selectedUniversity1, setSelectedUniversity1] = useState(null);
  const [searchText2, setSearchText2] = useState(cardDetails?.board || "");
  const [selectedUniversity2, setSelectedUniversity2] = useState(null);

  // useEffect(() => {
  //   const fetchUniversityNames = async () => {
  //     try {
  //       const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/universities`, {
  //         headers: headers
  //       });
  //       setUniversities(response.data);
  //     } catch (error) {
  //       console.error('Failed to fetch university names:', error);
  //     }
  //   };

  //   fetchUniversityNames();
  // }, [apiKey]);

  const handleSearchTextChange1 = (event, value) => {
    // setSearchText1(value);
    setSearchColleges(value);
    updateCardDetails({ institute: value.college_name });
  };

  const handleUniversityChange1 = (event, value) => {
    if (!value) {
      setSelectedUniversity1(null);
      updateCardDetails({ institute: "" }); // Clear the board/university field in the backend
    } else {
      setSelectedUniversity1(value);
      updateCardDetails({ institute: value.college_name });
    }

    if (value && value.university_name) {
      // console.log('Selected option:', value);
      setSearchUniversity(value?.university_name);
      setSelectedUniversity2({ name: value?.university_name });
      updateCardDetails({ board: value?.university_name });
    } else {
      setSearchUniversity("");
      setSelectedUniversity2(null);
      updateCardDetails({ board: "" });
    }
  };

  const handleSearchTextChange2 = (event, value) => {
    // setSearchText2(value);
    setSearchUniversity(value);
    updateCardDetails({ board: value.name });
  };

  const handleUniversityChange2 = (event, value) => {
    // Handle null values when the field is cleared

    console.log("University Name", value);
    if (!value) {
      setSelectedUniversity2(null);
      updateCardDetails({ board: "" }); // Clear the board/university field in the backend
    } else {
      setSelectedUniversity2(value);
      updateCardDetails({ board: value.name }); // Use the correct field
    }
  };

  const isCollege =
    cardDetails?.education_level === "UG" ||
    cardDetails?.education_level === "PG" ||
    cardDetails?.education_level === "HigherEd";

  // const uniqueUniversities1 = universities.filter((university) => university.toLowerCase().includes(searchText1.toLowerCase()));
  // const uniqueUniversities2 = universities.filter((university) => university.toLowerCase().includes(searchText2.toLowerCase()));

  // Ensure unique keys for Autocomplete options
  // const filteredUniversities1 = Array.from(new Set(uniqueUniversities1));
  // const filteredUniversities2 = Array.from(new Set(uniqueUniversities2));
  const { openSnackbar } = useQuantityContext();
  const dateOfBirth =
    cardDetails && cardDetails?.DOB ? cardDetails?.DOB.split("T")[0] : "";
  const userDOB = userDetails?.dob || "";
  const [maxDate, setMaxDate] = useState("");

  useEffect(() => {
    // Set maxDate to today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split("T")[0];
    setMaxDate(today);
  }, []);

  const handleDOBChange = (dateString) => {
    const dateObject = new Date(dateString);
    if (!isNaN(dateObject.getTime())) {
      setUserDetails((prevDetails) => ({
        ...prevDetails,
        dob: dateString,
      }));

      setCardDetails((prevDetails) => ({
        ...prevDetails,
        dob: dateString,
        isDbavailable: false,
      }));
    } else {
      console.error("Invalid date");
    }
  };

  // if(userDOB && userDOB!==''){
  //   setDbavailable(false)
  // }

  const handleInfo = (message = "", autoClose = 5000) => {
    let infoMessage;
    infoMessage = message;
    openSnackbar(infoMessage, "info", autoClose);
  };

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    updateCardDetails({ student_currently_pursuing: checked });
    updateCardDetails({ is_experience_current: checked });
  };

  // Effect to initialize cropper once selected image changes
  useEffect(() => {
    if (
      openDialog &&
      selectedImage &&
      !cropperInitialized &&
      cropperRef.current
    ) {
      console.log("Initializing cropper...");
      setCropperInitialized(true);
    }
  }, [openDialog, selectedImage, cropperInitialized]);

  // Function to handle cropper initialization
  const getCroppedCanvas = (instance) => {
    cropperRef.current = instance;
  };

  useEffect(() => {
    if (openDialog && selectedImage) {
      setCropperInitialized(false);
    }
  }, [selectedImage]);

  const [openDialogForNewField, setOpenDialogForNewField] = useState(false);
  const [newFieldName, setNewFieldName] = useState("");
  const [newFieldValue, setNewFieldValue] = useState("");

  const handleAddField = () => {
    if (newFieldName && newFieldValue) {
      setCardDetails((prevDetails) => ({
        ...prevDetails,
        additionalFields: {
          ...prevDetails.additionalFields,
          [newFieldName]: newFieldValue,
        },
      }));
      setNewFieldName("");
      setNewFieldValue("");
      setOpenDialogForNewField(false);
    }
  };

  const handleFieldChange = (key, event) => {
    setCardDetails((prevDetails) => ({
      ...prevDetails,
      additionalFields: {
        ...prevDetails.additionalFields,
        [key]: event.target.value,
      },
    }));
  };

  const handleRemoveField = (key) => {
    const { [key]: removedField, ...remainingFields } =
      cardDetails.additionalFields;
    setCardDetails((prevDetails) => ({
      ...prevDetails,
      additionalFields: remainingFields,
    }));
  };

  // Integrating new Colleges List API
  const [searchColleges, setSearchColleges] = useState(cardDetails?.institute);
  const [filteredColleges, setFilteredColleges] = useState([]);
  const [searchUniversity, setSearchUniversity] = useState(cardDetails?.board);
  const [filteredUniversities, setFilteredUniversities] = useState([]);
  const [offset, setOffset] = useState({
    colleges: 0,
    universities: 0,
  });
  const [hasMoreItems, setHasMoreItems] = useState({
    colleges: true,
    universities: true,
  }); // To track if more results are available
  const limit = 20;

  const fetchCollegesList = async () => {
    try {
      const reqObject = {
        search: searchColleges,
        limit: limit,
        offset: offset.colleges,
      };
      const response = await callApiFunction("getCollegesList", reqObject);

      if (response.status === "SUCCESS") {
        const allColleges = response.data.colleges;

        // If less than 20 colleges are fetched, no more data is available
        if (allColleges?.length < limit) {
          setHasMoreItems((prevState) => ({ ...prevState, colleges: false }));
        }

        setFilteredColleges((prevColleges) => [
          ...prevColleges,
          ...allColleges,
        ]);
      } else {
        console.error("Failed to fetch college data.");
      }
    } catch (err) {
      console.error("An error occurred while fetching college data.", err);
    }
  };

  const getPromptData = (cardType) => {
    switch (cardType) {
      case "Personal":
      case "Customize_Personal":
        return {
          name: userDetails.name,
          title: cardDetails?.title,
          nickName: cardDetails?.nickname,
          summary: cardDetails?.summary,
        };

      case "Professional":
      case "Customize_Professional":
        return {
          name: userDetails.name,
          company: cardDetails?.company,
          designation: cardDetails?.role_title,
          department: cardDetails?.profession_department,
          summary: cardDetails?.summary,
        };
      case "Student":
      case "Customize_Student":
        return {
          name: userDetails.name,
          title: cardDetails?.title,
          educationLevel: cardDetails?.education_level,
          institute: cardDetails?.institute,
          boardOrUniversity: cardDetails?.board,
          fieldOfStudy: cardDetails?.field_of_study,
          "Result Grade or Percentage": cardDetails?.grade,
          "Currently Pursuing?": cardDetails?.student_currently_pursuing,
          summary: cardDetails?.summary,
        };
    }
  };

  function getCardTypeForPrompt(cardType) {
    switch (cardType) {
      case "Personal":
      case "Customize_Personal":
        return "Personal";
      case "Professional":
      case "Customize_Professional":
        return "Professional";
      case "Student":
      case "Customize_Student":
        return "Student";
    }
  }

  const canGenerateSummary = () => {
    const { CardType } = cardDetails;
    const type = CardType?.toLowerCase();

    switch (type) {
      case "personal":
      case "customize_personal":
        return Boolean(
          cardDetails?.title || cardDetails?.nickname || cardDetails?.summary
        );

      case "professional":
      case "customize_professional":
        return Boolean(
          cardDetails?.company ||
          cardDetails?.role_title ||
          cardDetails?.profession_department ||
          cardDetails?.summary
        );

      case "student":
      case "customize_student":
        return Boolean(
          cardDetails?.education_level ||
          cardDetails?.institute ||
          cardDetails?.field_of_study ||
          cardDetails?.grade ||
          cardDetails?.summary
        );

      default:
        return false;
    }
  };

  const handleGenerateSummary = async () => {
    try {
      handleInfo("Generating your content...");
      const reqBody = {
        prompt: getPromptData(cardDetails.CardType),
        cardType: getCardTypeForPrompt(cardDetails.CardType),
      };
      const response = await API.post(
        "/api/v1/openai/generate-card-summary",
        reqBody
      );
      const responseData = response.data;
      if (responseData?.statusCode === 200) {
        updateCardDetails({
          summary: responseData?.data?.summary,
          details: responseData?.data?.summary,
        });
        handleSuccess("Content successfully generated!");
      }
    } catch (error) {
      console.error("Error generating description:", error);
      handleFailure("Failed to generate. Please try later.");
    }
  };

  // const fetchUniversitiesList = async () => {
  //   try {
  //     const reqObject = {
  //       search: searchUniversity,
  //       limit: limit,
  //       offset: offset.universities
  //     };
  //     const response = await callApiFunction('getUniversitiesList', reqObject);

  //     if (response.status === "SUCCESS") {
  //       const allUniversities = response.data.universities;

  //       // If less than 20 colleges are fetched, no more data is available
  //       if (allUniversities?.length < limit) {
  //         setHasMoreItems(prevState => ({ ...prevState, universities: false }));
  //       }

  //       setFilteredUniversities(prevUniversities => [...prevUniversities, ...allUniversities]);
  //     } else {
  //       console.error('Failed to fetch University data.');
  //     }
  //   } catch (err) {
  //     console.error('An error occurred while fetching university data.', err);
  //   }
  // };

  // Scroll event handler to detect if the user has reached the bottom of the dropdown

  const fetchUniversitiesList = async () => {
    const localStorageKey = "universities_Listdata";

    try {
      // Check LocalStorage first
      const storedData = localStorage.getItem(localStorageKey);
      if (storedData) {
        setFilteredUniversities(JSON.parse(storedData));
        setHasMoreItems((prevState) => ({ ...prevState, universities: false }));
        return;
      }

      // Fetch from API
      const response = await callApiFunction("getUniversitiesList", {
        limit: 3000,
        offset: 0,
      });
      console.log("universities data", response);
      if (response.status === "SUCCESS") {
        const newUniversities = response.data.universities;
        console.log("universities data", newUniversities);
        // Store in LocalStorage
        const storedData = localStorage.getItem(localStorageKey);
        const parsedData = storedData ? JSON.parse(storedData) : [];
        const updatedData = [...parsedData, ...newUniversities];
        localStorage.setItem(localStorageKey, JSON.stringify(updatedData));

        // Update State
        setFilteredUniversities((prevUniversities) => [
          ...prevUniversities,
          ...newUniversities,
        ]);

        // Check if more data is available
        if (newUniversities?.length < 3000) {
          setHasMoreItems((prevState) => ({
            ...prevState,
            universities: false,
          }));
        }
      } else {
        console.error("Failed to fetch University data.");
      }
    } catch (err) {
      console.error("An error occurred while fetching university data.", err);
    }
  };

  const handleDropdownScroll = (event, listName = "colleges") => {
    const bottom =
      event.target.scrollHeight - event.target.scrollTop ===
      event.target.clientHeight;

    if (bottom && hasMoreItems[listName]) {
      // Increment the offset for the correct list (colleges or universities)
      setOffset((prevOffset) => ({
        ...prevOffset,
        [listName]: prevOffset[listName] + limit, // Increment the correct offset key
      }));
    }
  };

  // useEffect to trigger fetch when the offset changes (pagination)
  // useEffect(() => {
  //   if (offset.colleges === 0) return; // Don't fetch data initially unless there's a search
  //   fetchCollegesList();
  // }, [offset.colleges]); // Trigger fetch when colleges offset changes

  useEffect(() => {
    if (offset.universities === 0) return; // Don't fetch data if no search term
    fetchUniversitiesList();
  }, [offset.universities]);

  // useEffect for when College search term changes
  useEffect(() => {
    const debounceSearch = setTimeout(() => {
      setFilteredColleges([]); // Clear previous results
      setOffset((prevOffset) => ({ ...prevOffset, colleges: 0 })); // Reset offset for new search
      setHasMoreItems((prevState) => ({ ...prevState, colleges: true })); // Reset hasMoreItems flag
      fetchCollegesList(); // Initial fetch for new search term
    }, 300);

    return () => clearTimeout(debounceSearch);
  }, [searchColleges]);

  // useEffect for when Universities search term changes
  useEffect(() => {
    const debounceSearch = setTimeout(() => {
      setFilteredUniversities([]); // Clear previous results
      setOffset((prevOffset) => ({ ...prevOffset, universities: 0 })); // Reset offset for new search
      setHasMoreItems((prevState) => ({ ...prevState, universities: true })); // Reset hasMoreItems flag
      fetchUniversitiesList();
    }, 300);

    return () => clearTimeout(debounceSearch);
  }, [searchUniversity]);

  return (
    <div>
      {/* <Box className='my-4 card-info-box' sx={{ border: "1px solid #17b200", backgroundColor: "white", borderRadius: 2, paddingTop: "16px" }}> */}
      <div style={{ paddingRight: "16px", paddingLeft: "16px" }}>
        <div className="card-edit-info-heading">
          <h5>Profile Information</h5>
          <span>
            Add your profile information to show in your digital business card
          </span>
        </div>
        <div className="profile-and-logo my-4 mt-4">
          <div className="profile-picture-container text-center">
            <h5>Profile Picture</h5>
            <div>
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                badgeContent={
                  <Avatar sx={{ bgcolor: "#0044C6" }}>
                    <label
                      htmlFor="profilePicture-input"
                      style={{ cursor: "pointer" }}
                    >
                      <EditRoundedIcon />
                    </label>
                    <input
                      id="profilePicture-input"
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleFileSelect}
                    />
                  </Avatar>
                }
              >
                <Avatar
                  sx={{ bgcolor: "#F4F7FE", width: "130px", height: "130px" }}
                >
                  {cardDetails.profile_pic !== "" ? (
                    <img
                      src={cardDetails?.profile_pic}
                      alt="profilepicture"
                      className="profile-pic-avatar"
                    />
                  ) : (
                    <InsertPhotoIcon sx={{ color: "grey" }} fontSize="large" />
                  )}
                </Avatar>
              </Badge>
            </div>
          </div>

          {!(
            cardDetails?.CardType === "Personal" ||
            cardDetails?.CardType === "Customize_Personal"
          ) && (
              <FileDragUpload
                label="Add Logo"
                contextKey="logo"
                accept={["image/jpeg", "image/png"]}
                maxSize={1}
                inputId="companyLogo-input"
                useContext={useCardDetailContext}
              />
            )}
        </div>

        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <DialogTitle>Crop Image</DialogTitle>
          <DialogContent>
            <div
              style={{ width: "100%", height: "400px", position: "relative" }}
            >
              <Cropper
                ref={cropperRef}
                src={selectedImage}
                style={{ height: "100%", width: "100%" }}
                initialAspectRatio={1}
                guides={true}
                cropBoxMovable={true}
                cropBoxResizable={true}
                crossOrigin="anonymous"
                dragMode="crop"
                viewMode={1}
                background={false}
                responsive={true}
                autoCrop={false}
                autoCropArea={1}
                minCropBoxHeight={20}
                minCropBoxWidth={20}
                checkOrientation={false}
                onInitialized={handleCropperInitialized}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCropSave}>Save</Button>
          </DialogActions>
        </Dialog>

        <div className="my-2 user-details-container">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  <FormControl fullWidth>
                    <TextField
                      name="Category"
                      label="Category"
                      required
                      select
                      value={cardDetails?.CardType}
                      InputLabelProps={{ required: false }}
                      fullWidth
                      className="textfield-widthNew"
                      disabled
                      style={{ marginBottom: "16px" }} // Add space here
                    >
                      <MenuItem value="Personal">Personal</MenuItem>
                      <MenuItem value="Professional">Professional</MenuItem>
                      <MenuItem value="Student">Student</MenuItem>
                      <MenuItem value="GenZ">GenZ</MenuItem>
                      <MenuItem value="Customize_Personal">Customize</MenuItem>
                      <MenuItem value="Customize_Professional">
                        Customize
                      </MenuItem>
                      <MenuItem value="Customize_Student">Customize</MenuItem>
                      <MenuItem value="Customize_GenZ">Customize</MenuItem>
                    </TextField>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  {cardDetails?.CardType?.startsWith("Customize_") && (
                    <TextField
                      label="Card Name"
                      fullWidth
                      value={cardDetails?.CardName}
                      onChange={handleChangeCardName}
                      style={{ marginBottom: "16px" }} // Add space here
                      disabled
                      inputProps={{ maxLength: 20 }}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>

        <div className="my-2 user-details-container">
          <Grid container spacing={2}>
            {/* First Column */}
            <Grid item xs={6}>
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  <TextField
                    value={firstName}
                    label="First Name"
                    fullWidth
                    disabled
                    inputProps={{ maxLength: 90 }}
                  />
                </Grid>
                <Grid item>
                  <TextField
                    label="Date of Birth"
                    type="date"
                    value={userDetails?.dob}
                    onChange={(event) => handleDOBChange(event.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      inputProps: {
                        max: maxDate, // Set the max attribute dynamically
                      },
                    }}
                    fullWidth
                  // disabled={Boolean(userDetails?.dob)}
                  />
                </Grid>
                <Grid item>
                  <TextField
                    label="Suffix"
                    fullWidth
                    value={cardDetails?.suffix}
                    onChange={handleInputChange("suffix")}
                    inputProps={{ maxLength: 6 }}
                  />
                </Grid>
                <Grid item>
                  {cardDetails?.CardType === "Personal" ||
                    cardDetails?.CardType === "Customize_Personal" ? (
                    <TextField
                      label="Title"
                      fullWidth
                      value={cardDetails?.title}
                      onChange={handleInputChange("title")}
                      inputProps={{ maxLength: 22 }}
                    />
                  ) : cardDetails?.CardType === "Professional" ||
                    cardDetails?.CardType === "Customize_Professional" ? (
                    <TextField
                      label="Department"
                      fullWidth
                      value={cardDetails?.profession_department}
                      onChange={handleInputChange("profession_department")}
                      inputProps={{ maxLength: 30 }}
                    />
                  ) : cardDetails?.CardType === "Student" ||
                    cardDetails?.CardType === "Customize_Student" ? (
                    <FormControl fullWidth>
                      <TextField
                        name="Education"
                        label="Education Level"
                        required
                        select
                        value={cardDetails?.education_level}
                        onChange={handleInputChange("education_level")}
                        fullWidth
                        className="textfield-widthNew"
                      >
                        <MenuItem value="SSLC">10th/SSLC/SSC</MenuItem>
                        <MenuItem value="HSC">12th/PUC/HSC</MenuItem>
                        <MenuItem value="UG">Undergraduate</MenuItem>
                        <MenuItem value="PG">Post Graduate</MenuItem>
                        <MenuItem value="HigherEd">Higher Education</MenuItem>
                      </TextField>
                    </FormControl>
                  ) : null}
                </Grid>
                {cardDetails?.CardType === "Student" ||
                  cardDetails?.CardType === "Customize_Student" ? (
                  <>
                    <Grid item>
                      {/* <FormControl fullWidth>
                        <Autocomplete
                          value={selectedUniversity1}
                          onChange={handleUniversityChange1}
                          inputValue={searchColleges || ""}
                          onInputChange={handleSearchTextChange1}
                          options={isCollege ? filteredColleges || [] : []}
                          freeSolo
                          getOptionLabel={(option) => (option?.college_name ? option.college_name : "")}
                          ListboxProps={{
                            onScroll: handleDropdownScroll
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Institute"
                              variant="outlined"
                              fullWidth
                            />
                          )}
                        />
                      </FormControl> */}
                      <FormControl fullWidth>
                        <Autocomplete
                          value={selectedInstitute}
                          freeSolo
                          options={searchItems || []}
                          inputValue={cardInstitueSearchItem || ""}
                          onInputChange={(event, value) => {
                            setMenuItem("Student"); // Set correct menu context
                            handleSearchLogo(event, value); // Same search logic
                          }}
                          onChange={(event, value) =>
                            handleSelected(event, value)
                          } // Reuse the same handler
                          getOptionLabel={(option) =>
                            typeof option === "string"
                              ? option
                              : option?.legal_name || ""
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Institute"
                              variant="outlined"
                              fullWidth
                              required
                            // error={eduErrors?.institute}
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                    {cardDetails.education_level !== "SSLC" && (
                      <Grid item>
                        <TextField
                          label={
                            cardDetails.education_level === "HSC"
                              ? "Subjects"
                              : "Field of Study"
                          }
                          value={cardDetails.field_of_study}
                          onChange={handleInputChange("field_of_study")}
                          fullWidth
                          inputProps={{ maxLength: 90 }}
                        />
                      </Grid>
                    )}
                    <Grid item>
                      <TextField
                        label="Student ID"
                        fullWidth
                        value={cardDetails.student_id}
                        onChange={handleInputChange("student_id")}
                        inputProps={{ maxLength: 18 }}
                      />
                    </Grid>
                    <Grid item>
                      <FormControl fullWidth required>
                        <InputLabel id="start-year-label">Start Year</InputLabel>
                        <Select
                          labelId="year-label"
                          value={cardDetails?.start_year || ""}
                          onChange={handleInputChange("start_year")}
                          label="Start year"
                          className="text-left"
                          required
                        >
                          {years?.map((year, index) => (
                            <MenuItem key={index} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={cardDetails?.student_currently_pursuing}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="Currently Pursuing"
                      />
                    </Grid>
                  </>
                ) : null}
              </Grid>
            </Grid>

            {/* Second Column */}
            <Grid item xs={6}>
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  <TextField
                    value={lastName}
                    label="Last Name"
                    disabled
                    fullWidth
                    inputProps={{ maxLength: 90 }}
                  />
                </Grid>

                <Grid item>
                  <TextField
                    label="Prefix"
                    fullWidth
                    value={cardDetails?.prefix}
                    onChange={handleInputChange("prefix")}
                    inputProps={{ maxLength: 6 }}
                  />
                </Grid>

                <Grid item>
                  {cardDetails?.CardType === "Personal" ||
                    cardDetails?.CardType === "Customize_Personal" ? (
                    <TextField
                      label="Personal Email"
                      disabled
                      fullWidth
                      value={userDetails.email}
                      inputProps={{ maxLength: 48 }}
                    />
                  ) : cardDetails?.CardType === "Professional" ||
                    cardDetails?.CardType === "Customize_Professional" ? (
                    // <TextField label="Company" fullWidth value={cardDetails?.company} onChange={handleInputChange('company')} inputProps={{ maxLength: 42 }} />
                    <Autocomplete
                      freeSolo
                      options={searchItems || []}
                      value={selectedExperience}
                      inputValue={companySearchTerm}
                      onInputChange={handleSearchLogo}
                      onChange={handleSelected}
                      getOptionLabel={(option) =>
                        typeof option === "string"
                          ? option
                          : option?.legal_name || ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Company"
                          variant="outlined"
                          fullWidth
                          onClick={() => {
                            setMenuItem("Professional");
                          }}
                        />
                      )}
                    />
                  ) : cardDetails?.CardType === "Student" ||
                    cardDetails?.CardType === "Customize_Student" ? (
                    <TextField
                      label="Title"
                      fullWidth
                      value={cardDetails?.title}
                      onChange={handleInputChange("title")}
                      inputProps={{ maxLength: 22 }}
                    />
                  ) : null}
                </Grid>
                <Grid item>
                  {cardDetails?.CardType === "Personal" ||
                    cardDetails?.CardType === "Customize_Personal" ||
                    cardDetails?.CardType === "Student" ||
                    cardDetails?.CardType === "Customize_Student" ? (
                    <TextField
                      label="Nickname"
                      fullWidth
                      value={cardDetails?.nickname}
                      onChange={handleInputChange("nickname")}
                      inputProps={{ maxLength: 18 }}
                    />
                  ) : cardDetails?.CardType === "Professional" ||
                    cardDetails?.CardType === "Customize_Professional" ? (
                    <TextField
                      label="Role Title"
                      fullWidth
                      value={cardDetails?.role_title}
                      onChange={handleInputChange("role_title")}
                      inputProps={{ maxLength: 22 }}
                    />
                  ) : cardDetails?.CardType === "Student" ||
                    cardDetails?.CardType === "Customize_Student" ? (
                    <FormControl fullWidth>
                      <Autocomplete
                        value={selectedUniversity2}
                        onChange={handleUniversityChange2}
                        inputValue={searchUniversity || ""}
                        onInputChange={handleSearchTextChange2}
                        options={isCollege ? filteredUniversities || [] : []}
                        freeSolo
                        getOptionLabel={(option) =>
                          option?.name ? option.name : ""
                        }
                        ListboxProps={{
                          onScroll: (event) =>
                            handleDropdownScroll(event, "universities"),
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Board/University"
                            variant="outlined"
                            fullWidth
                          />
                        )}
                      />
                    </FormControl>
                  ) : null}
                </Grid>
                {cardDetails?.CardType === "Student" ||
                  cardDetails?.CardType === "Customize_Student" ? (
                  <>
                    {cardDetails.education_level !== "SSLC" && (
                      <Grid item>
                        <TextField
                          label={
                            cardDetails.education_level === "HSC"
                              ? "Stream"
                              : "Degree"
                          }
                          value={cardDetails.degree}
                          onChange={handleInputChange("degree")}
                          fullWidth
                          inputProps={{ maxLength: 48 }}
                        />
                      </Grid>
                    )}
                    <Grid item>
                      <TextField
                        label="Grade/GPA"
                        value={cardDetails.grade}
                        onChange={handleInputChange("grade")}
                        fullWidth
                        inputProps={{ maxLength: 18 }}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        label="Student Email ID"
                        fullWidth
                        value={cardDetails.student_email_id}
                        onChange={handleInputChange("student_email_id")}
                        inputProps={{ maxLength: 48 }}
                      />
                    </Grid>
                    <Grid item>
                      {/* <TextField
                        label="Ending Year"
                        fullWidth
                        value={cardDetails?.student_currently_pursuing === true ? 'present' : cardDetails.student_ending_year}
                        onChange={handleInputChange('student_ending_year')}
                        disabled={cardDetails?.student_currently_pursuing}
                      /> */}
                      {cardDetails?.student_currently_pursuing ? (
                        <TextField
                          label="Ending Year"
                          fullWidth
                          value="Present"
                          disabled
                          InputProps={{
                            style: { color: "black" }, // optional
                          }}
                        />
                      ) : (
                        <FormControl fullWidth>
                          <InputLabel id="ending-year-label">Ending Year</InputLabel>
                          <Select
                            labelId="ending-year-label"
                            value={cardDetails?.student_ending_year || ""}
                            onChange={handleInputChange("student_ending_year")}
                            label="Ending Year"
                            className="text-left"
                          >
                            {years?.map((year, index) => (
                              <MenuItem key={index} value={year}>
                                {year}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Grid>
                  </>
                ) : null}
              </Grid>
            </Grid>

            {/* <Grid item xs={6}>
              <TextField label="Website" fullWidth value={cardDetails?.company_website || cardDetails?.institute_domain} onChange={handleInputChange('company_website')} />
            </Grid> */}

            {(cardDetails?.CardType === "Personal" ||
              cardDetails?.CardType === "Customize_Personal") && (
                <Grid item xs={6}>
                  <TextField
                    label="Website"
                    fullWidth
                    value={(
                      cardDetails?.company_website ||
                      selectedCardEducation?.institute_domain ||
                      cardDetails?.institute_website ||
                      ""
                    ).toString()}
                    onChange={handleInputChange("company_website")}
                  />
                </Grid>
              )}

            {(cardDetails?.CardType === "Professional" ||
              cardDetails?.CardType === "Customize_Professional") && (
                <>
                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <Autocomplete
                        freeSolo
                        options={searchItems || []}
                        value={selectedExperienceDomain}
                        inputValue={professionalSearchDomain || ""}
                        onInputChange={handleSearchDomain} // This updates searchQuery
                        onChange={handleSelectedDomain}
                        getOptionLabel={(option) =>
                          typeof option === "string"
                            ? option
                            : option?.website || ""
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="Website"
                            label="Website"
                            variant="outlined"
                            fullWidth
                            onClick={() => {
                              setMenuItem("Professional"); //  This is where you set it
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      name="location"
                      label="Location"
                      required
                      className="course-name"
                      fullWidth
                      value={cardDetails?.location}
                      // onChange={handleExperienceItems("location")}
                      onChange={handleInputChange("location")}
                    // error={expErrors?.location}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl
                      fullWidth
                      required
                    // error={expErrors?.locationType}
                    >
                      <TextField
                        name="locationType"
                        label="Location Type"
                        select
                        value={cardDetails?.location_type}
                        // onChange={handleExperienceItems("locationType")}
                        onChange={handleInputChange("location_type")}
                        InputLabelProps={{ required: false }}
                        fullWidth
                        className="textfield-widthNew"
                      >
                        <MenuItem value="Onsite">Onsite</MenuItem>
                        <MenuItem value="Hybrid">Hybrid</MenuItem>
                        <MenuItem value="Remote">Remote</MenuItem>
                      </TextField>
                    </FormControl>
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl
                      fullWidth
                      required
                    // error={expErrors?.employmentType}
                    >
                      <TextField
                        name="employmentType"
                        label="Employment Type"
                        select
                        value={cardDetails?.employee_type}
                        // onChange={handleExperienceItems("employmentType")}
                        onChange={handleInputChange("employee_type")}
                        InputLabelProps={{ required: false }}
                        fullWidth
                        className="textfield-widthNew"
                      >
                        <MenuItem value="Full-time">Full-time</MenuItem>
                        <MenuItem value="Part-time">Part-time</MenuItem>
                        <MenuItem value="Freelance">Freelance</MenuItem>
                        <MenuItem value="Internship">Internship</MenuItem>
                        <MenuItem value="Trainee">Trainee</MenuItem>
                      </TextField>
                    </FormControl>
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl
                      fullWidth
                      required
                    // error={expErrors?.startYear}
                    >
                      <InputLabel id="start-year-label">Start Year</InputLabel>
                      <Select
                        labelId="year-label"
                        value={cardDetails?.start_year || ""}
                        // onChange={handleExperienceItems("startYear")}
                        onChange={handleInputChange("start_year")}
                        label="Start year"
                        className="text-left"
                        required
                      >
                        {years?.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <Grid item xs={12}>
                      <FormControlLabel fullWidth
                        control={
                          <Checkbox
                            checked={!!cardDetails.is_experience_current}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="Currently working"
                      />
                    </Grid>
                    <Grid item xs={12} className="my-3 ">
                      <Autocomplete
                        freeSolo
                        options={kpiOptions}
                        multiple
                        PaperComponent={customHealthPaper}
                        PopperComponent={(props) => (
                          <Popper
                            {...props}
                            style={{ marginLeft: "100px", width: 500 }}
                          />
                        )}
                        value={
                          Array.isArray(cardDetails?.responsibility)
                            ? cardDetails.responsibility
                            : typeof cardDetails?.responsibility === "string"
                              ? cardDetails.responsibility
                                .split(",")
                                .map((item) => item.trim())
                              : []
                        }
                        // value={Array.isArray(cardDetails?.responsibility) ? cardDetails.responsibility : []}
                        onChange={(event, newValue) =>
                          updateCardDetails({
                            ...cardDetails,
                            responsibility: Array.isArray(newValue)
                              ? newValue
                              : [],
                          })
                        }
                        inputValue={responsibilityInput}
                        onInputChange={(event, newInputValue) => {
                          setResponsibilityInput(newInputValue); // Update the input value
                        }}
                        onKeyDown={(event) =>
                          handleAddChip(
                            event,
                            responsibilityInput,
                            "responsibility"
                          )
                        }
                        renderTags={(value, getTagProps) =>
                          value?.map((option, index) => (
                            <CustomChip
                              key={index}
                              variant="outlined"
                              label={option}
                              onDelete={() =>
                                handleDeleteChip("responsibility", option)
                              }
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Responsibilities"
                          // placeholder="Your Key Responsibilities"
                          />
                        )}
                      />
                    </Grid>
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl
                      fullWidth
                      required
                    // error={
                    //   expErrors?.endYear ||
                    //   expErrors?.endMonthInvalid ||
                    //   expErrors?.endYearInvalid
                    // }
                    >
                      <InputLabel id="end-year-label">End Year</InputLabel>
                      <Select
                        labelId="year-label"
                        value={cardDetails?.end_year || ""}
                        // onChange={handleExperienceItems("endYear")}
                        onChange={handleInputChange("end_year")}
                        label="End year"
                        className="text-left"
                        disabled={cardDetails?.is_experience_current}
                      >
                        {cardDetails.is_experience_current && (
                          <MenuItem value="Present">Present</MenuItem>
                        )}
                        {years?.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <Box height={40} />
                    <Grid className="my-3">
                      <TextField
                        label="Profile headline"
                        fullWidth
                        value={cardDetails?.profile_headline}
                        onChange={handleInputChange("profile_headline")}
                        inputProps={{ maxLength: 30 }}
                      />
                      {/* <Grid item xs={12}> */}
                    </Grid>
                  </Grid>
                </>
              )}

            {(cardDetails?.CardType === "Student" ||
              cardDetails?.CardType === "Customize_Student") && (
                <>
                  <Grid item xs={6}>
                    {/* <TextField label="Website" fullWidth value={(cardDetails?.company_website || selectedCardEducation?.institute_domain || cardDetails?.institute_website || "").toString()} onChange={handleInputChange('company_website')} />
                   */}

                    <FormControl fullWidth>
                      <Autocomplete
                        freeSolo
                        options={searchItems || []}
                        value={selectedExperienceDomain}
                        inputValue={studentDomainSearchItem || ""}
                        onInputChange={handleSearchDomain} // This updates searchQuery
                        onChange={handleSelectedDomain}
                        getOptionLabel={(option) =>
                          typeof option === "string"
                            ? option
                            : option?.website || ""
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="companyDomain"
                            label="Website"
                            variant="outlined"
                            fullWidth
                            onClick={() => {
                              setMenuItem("Student"); //  This is where you set it
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                </>
              )}

            {/* <Grid item xs={6}>
                  <TextField label="University Website" fullWidth value={cardDetails?.university_website} onChange={handleInputChange('university_website')} />
                </Grid> */}

            <Grid item xs={12}>
              <Grid item>
                <TextField
                  multiline
                  label="Description"
                  className="summary-field"
                  fullWidth
                  value={cardDetails?.summary}
                  onChange={handleInputChange("summary")}
                  inputProps={{ maxLength: 2000 }}
                />
                <div className="d-flex justify-content-end align-items-start my-2">
                  {/* <div className="invite-modal-subtitle">Enable AI Generation with minimum 15 words</div> */}
                  <Button
                    variant="outlined"
                    sx={{ color: "#0044C6" }}
                    className="ai-rewrite-button"
                    onClick={handleGenerateSummary}
                    disabled={!canGenerateSummary()}
                    startIcon={<AiLogo />}
                  >
                    Generate
                  </Button>
                </div>
              </Grid>
            </Grid>

            {Object.keys(cardDetails?.additionalFields ?? {}).map((key) => (
              <Grid item xs={6} key={key}>
                <Grid item>
                  <TextField
                    label={key} // Display the field name
                    value={cardDetails.additionalFields[key]} // Display the field value
                    onChange={(event) => handleFieldChange(key, event)}
                    fullWidth
                  />
                </Grid>
              </Grid>
            ))}
          </Grid>
          {cardDetails?.CardType?.startsWith("Customize_") && (
            <div
              className="my-2 py-2 d-flex align-items-center color-blue"
              onClick={() => setOpenDialogForNewField(true)}
            >
              <div className={`icon me-1 ms-0`}>
                <FaPlusCircle className="color-blue" />
              </div>
              Add More Fields
            </div>
          )}
        </div>
      </div>

      <Dialog
        open={openDialogForNewField}
        onClose={() => setOpenDialogForNewField(false)}
        fullWidth
        sx={{ "& .MuiDialog-paper": { maxWidth: "520px" } }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          <Typography variant="h6">Add More Fields</Typography>
          <IconButton
            aria-label="close"
            onClick={() => setOpenDialogForNewField(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseRoundedIcon />
          </IconButton>
        </DialogTitle>
        <Typography
          gutterBottom
          sx={{ padding: "0 16px", marginBottom: "15px" }}
        >
          Add custom fields to enhance more details.
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "0 16px",
          }}
        >
          {Object.keys(cardDetails?.additionalFields ?? {}).map((key) => (
            <>
              <Grid item style={{ width: "85%" }}>
                <TextField
                  placeholder="Name"
                  variant="standard"
                  fullWidth
                  value={key}
                  disabled
                  sx={{ mb: 2 }}
                />
              </Grid>
              <div
                className="d-flex align-items-center"
                style={{ width: "100%" }}
              >
                <Grid item style={{ width: "85%" }}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    value={cardDetails.additionalFields[key]}
                    disabled
                    sx={{ mb: 2 }}
                  />
                </Grid>
                <IconButton
                  onClick={() => handleRemoveField(key)}
                  sx={{ marginLeft: 1 }}
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            </>
          ))}
          <Grid item style={{ width: "85%" }}>
            <TextField
              placeholder="Name"
              variant="standard"
              fullWidth
              value={newFieldName}
              onChange={(e) => setNewFieldName(e.target.value)}
              error={isOnlyNumbers.test(newFieldName)}
              helperText={
                isOnlyNumbers.test(newFieldName)
                  ? "Input must not be numbers only"
                  : ""
              }
              sx={{ mb: 2 }}
            />
          </Grid>
          <div className="d-flex align-items-center" style={{ width: "100%" }}>
            <Grid item style={{ width: "85%" }}>
              <TextField
                label="Input"
                variant="outlined"
                fullWidth
                value={newFieldValue}
                onChange={(e) => setNewFieldValue(e.target.value)}
                sx={{ mb: 2 }}
              />
            </Grid>
            <IconButton onClick={handleAddField} sx={{ marginLeft: 1 }}>
              <FaPlusCircle className="icon-color" />
            </IconButton>
          </div>
        </Box>
        {/* <DialogActions>
          <Button onClick={() => setOpenDialogForNewField(false)} sx={{ backgroundColor: "#0044C6" }} variant="contained">
            Save
          </Button>
        </DialogActions> */}
      </Dialog>
      <div
        className="save-bottom"
        style={{
          textAlign: "right",
          backgroundColor: "#0044C614",
          padding: "12px",
          borderRadius: "0 0 8px 8px",
        }}
      >
        <Button
          variant="contained"
          sx={{ backgroundColor: "#0044C6" }}
          onClick={handleSave}
          disabled={!SaveEnable}
        >
          Save
        </Button>
      </div>
      {/* <ToastContainer toastClassName="email-toast-success" /> */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        message={
          <div>
            <strong>{snackbarMessage.title}</strong>
            <div>{snackbarMessage.body}</div>
          </div>
        }
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleCloseSnackbar}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        anchorOrigin={{
          vertical: "top", // Position at the top
          horizontal: "right", // Position at the right
        }}
      />
      {/* </Box> */}
    </div>
  );
};

export default ProfileDetails;
